
export const links: any = {
    "at11house": "https://www.eventbrite.com/e/astral-travel-with-todd-mitchell-tickets-889921829147"
}

